// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__6Qux4","bigColWidth":"Table_bigColWidth__3i-SR","biggerColWidth":"Table_biggerColWidth__Ivv9K","row":"Table_row__39BC6","col":"Table_col__3KPs7"};